import ClientId from '~/constants/ClientId';
import didSetNativeAppCapabilities from '~/constants/common/didSetNativeAppCapabilities';
import type KubernetesAppName from '~/constants/common/KubernetesAppName';
import { getAppCapabilitiesCookieName } from '~/native/utils';
import BrowserCookies from '~/utilities/BrowserCookies';
import getBranchCookieName from './getBranchCookieName';
import getEnabledCookieName from './getEnabledCookieName';

export default function clearFeatureCookies(
  kubernetesAppName: KubernetesAppName,
  clientId: ClientId
): () => void {
  return () => {
    BrowserCookies.remove(getEnabledCookieName(kubernetesAppName));
    BrowserCookies.remove(getBranchCookieName(kubernetesAppName));
    BrowserCookies.remove(getAppCapabilitiesCookieName(clientId));
    BrowserCookies.remove(didSetNativeAppCapabilities[clientId] ?? '');

    window.location.reload();
  };
}
